import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Register from "./pages/Register";
import AcceptInvitation from "./pages/AcceptInvitation";
import Dashboard from "./pages/Dashboard";
import SettingsOrganization from "./pages/settings/Organization";
import SettingsUsers from "./pages/settings/Users";
import SettingsProfile from "./pages/settings/Profile";
import Frameworks from "./pages/Frameworks";
import Questionnaire from "./pages/Questionnaire";
import SoA from "./pages/SoA";
import ControlDetail from "./pages/ControlDetail";
import Documents from "./pages/Documents";
import DocumentEditor from "./pages/DocumentEditor";
import Evidences from "./pages/Evidences";
import EvidenceDetail from "./pages/EvidenceDetail";
import Journey from "./pages/Journey";
import JourneyStep from "./pages/JourneyStep";
import SgsiMap from "./pages/SgsiMap";
import Imports from "./pages/Imports";
import ImportDetail from "./pages/ImportDetail";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/accept-invitation/:token" element={<AcceptInvitation />} />

          <Route
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/settings/organization" element={<SettingsOrganization />} />
            <Route path="/settings/users" element={<SettingsUsers />} />
            <Route path="/settings/profile" element={<SettingsProfile />} />
            <Route path="/frameworks" element={<Frameworks />} />
            <Route path="/questionnaire/:framework" element={<Questionnaire />} />
            <Route path="/soa" element={<SoA />} />
            <Route path="/controls/:id" element={<ControlDetail />} />
            <Route path="/documents" element={<Documents />} />
            <Route path="/documents/:id" element={<DocumentEditor />} />
            <Route path="/evidences" element={<Evidences />} />
            <Route path="/evidences/:id" element={<EvidenceDetail />} />
            <Route path="/ruta" element={<Journey />} />
            <Route path="/ruta/pasos/:code" element={<JourneyStep />} />
            <Route path="/mapa" element={<SgsiMap />} />
            <Route path="/importar" element={<Imports />} />
            <Route path="/importar/:id" element={<ImportDetail />} />
          </Route>

          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors closeButton position="top-right" />
    </div>
  );
}

export default App;
